import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { ChargeDispute } from "../../../../../models";

import AppLink from "../../../../../components/AppLink";
import { ROUTES } from "../../../../../history";
import dayjs from "dayjs";

const ChargeDisputeListWidget: React.FC<{
  chargedispute: ChargeDispute;
  active?: boolean;

  onClickCheck?: (p: ChargeDispute) => void;
}> = ({ chargedispute, active = false, onClickCheck }) => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        <Box display="flex" alignItems={"center"}>
          <Box
            display="inline-block"
            sx={{
              mr: 1,
            }}
          ></Box>
          <AppLink
            doNotUseButton
            to={
              ROUTES.ADMIN_BASE +
              "/refunds/charge-disputes/view/" +
              chargedispute.id
            }
          >
            <Typography component="span" fontSize="14px" fontWeight={"bold"}>
              {" "}
              {dayjs(chargedispute.createdAt).format("MMM D, YYYY")}
            </Typography>
          </AppLink>{" "}
        </Box>
      </TableCell>
      <TableCell align="right">
      <AppLink
            doNotUseButton
            to={
              ROUTES.ADMIN_BASE +
              "/transactions/view/" +
              chargedispute.Transaction
            }
          >
            <Typography fontSize="14px" color="blue">View Transaction</Typography>
            </AppLink>
        </TableCell>

      <TableCell align="right">{chargedispute.status}</TableCell>
    </TableRow>
  );
};

export default ChargeDisputeListWidget;
